import {
	type DcrLicenseInput,
	ReferenceType
} from '@/core/graphql/generated/types';

import { labelKey as t } from '../labelKey';
import type { CollectionDef, HistoricFieldDef, ItemFieldDef } from '../types';

export const LICENSING_AUTHORITY_MAX_LENGTH = 20;

export const LICENSE_FIELDS = {
	licenseNumber_V: {
		label: t('License ID'),
		kind: 'text',
		visibility: 'always',
		inline: { required: true }
	},
	typeValue_V: {
		label: t('Licensing Authority'),
		kind: 'text',
		visibility: 'always',
		maxLength: LICENSING_AUTHORITY_MAX_LENGTH,
		backendNames: ['typeValue_VId']
	},
	expirationDate_V: {
		label: t('Expiration Date'),
		kind: 'date',
		visibility: 'always'
	},
	licenseStatus_VId: {
		label: t('License Status'),
		kind: 'picklist',
		picklist: ReferenceType.LicenseStatus,
		visibility: 'always'
	}
} as const satisfies Partial<Record<keyof DcrLicenseInput, ItemFieldDef>>;

export const LICENSE_HISTORIC_FIELDS: readonly HistoricFieldDef[] = [
	{ names: ['licenses_V'], label: t('License') },
	{ names: ['licenseDegree_V'], label: t('License Degree') },
	{ names: ['gracePeriod_V'], label: t('Grace Expiry') },
	{ names: ['rxaEligible_V'], label: t('Sample Eligibility') },
	{ names: ['type_V'], label: t('License Type') },
	{ names: ['licenseSubtype_V'], label: t('License SubType') },
	{ names: ['body_V'], label: t('Licensing Body') },
	{ names: ['licenseCertification_V'], label: t('License Certification') },
	{ names: ['bestStateLicense_V'], label: t('Best State License') },
	{ names: ['licenseEligibility_V'], label: t('Prescriptive Authority') },
	{
		names: ['licenseStatusCondition_V'],
		label: t('License Status Condition')
	},
	{
		names: ['comprehensivePrescriptiveAuthority_V'],
		label: t('Comprehensive Prescriptive Authority')
	},
	{
		names: ['comprehensiveSampleEligibility_V'],
		label: t('Comprehensive Sample Eligibility')
	},
	{
		names: ['collabAgreeRequired_V'],
		label: t('Collaborative Agreement Required')
	},
	{
		names: ['ctrlSubstancePrescriptive_V'],
		label: t('Controlled Substances Prescriptive Authority')
	},
	{
		names: ['ctrlSubstanceSample_V'],
		label: t('Controlled Substances Sample Eligibility')
	},
	{ names: ['deaBusinessActivityCode_V'], label: t('DEA Activity Code') },
	{ names: ['deaPaymentIndicator_V'], label: t('DEA Payment Indicator') },
	{ names: ['drugSchedule_V'], label: t('Drug Schedule Details') }
];

export const LICENSE_COLLECTION: CollectionDef = {
	id: 'license',
	itemLabel: t('License'),
	addLabel: t('Add License'),
	fields: LICENSE_FIELDS
};
